<template>
  <div class="option-selector modal" ref="optionSelector">
    <h5 class="modal-title">{{ name }}</h5>
    <div class="modal-content">
      <div class="content-container row">
        <div
          class="option-wrapper center-align"
          :class="[$_getGrid()]"
          v-for="(opt, index) in options"
          :key="index"
        >
          <div
            class="img-wrapper"
            :class="[{ 'img-wrapper-survey': dataForSurvey }]"
            @click="$_updateValue(opt)"
          >
            <img :src="$_getImg(opt.localImage)" alt="" srcset="" />
          </div>
          <p class="text-label" @click="$_updateValue(opt)">{{ opt.text }}</p>
          <div>
            <label>
              <input
                type="radio"
                class="filled-in"
                :value="opt.value"
                v-model="selectedValue"
                @change="$_updateValue(opt)"
              />
              <span></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import M from "materialize-css";
export default {
  name: "OptionSelector",
  props: {
    dataValue: {
      type: [String, Number],
      default: () => "",
    },
    name: {
      type: String,
      default: () => "",
    },
    dataOptions: {
      type: Array,
      default: () => [],
    },
    gridStyle: {
      type: Object,
      default: () => {},
    },
    dataForSurvey: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    let vm = this;
    return {
      modal: {
        instance: null,
        options: {
          onCloseEnd: () => {
            vm.$_updateValue();
          },
          //   dismissible: false,
        },
      },
      selectedValue: this.dataValue,
    };
  },
  beforeDestroy() {
    if (this.modal.instance) {
      this.modal.instance.destroy();
    }
  },
  mounted() {
    this.$_initModel();
  },
  computed: {
    options() {
      const value = this.dataOptions.filter((item) => !item.default);
      return value;
    },
  },
  methods: {
    $_initModel() {
      this.modal.instance = M.Modal.init(
        this.$refs.optionSelector,
        this.modal.options
      );

      setTimeout(() => {
        this.modal.instance.open();
      });
    },

    $_updateValue(opt) {
      if (opt) {
        this.selectedValue = opt.value;
      }
      this.$emit("updateSelector", this.selectedValue);
      this.modal.instance.close();
    },

    $_getImg(pic) {
      if (pic) {
        return require("@/assets/" + pic);
      }
    },
    $_getGrid() {
      if (!this.gridStyle.grid) {
        // return this.options.length > 4 ? "col s3" : "col s6";
        return "col s6";
      } else {
        return this.gridStyle.grid;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.option-selector {
  border-radius: 10px;
  h5 {
    text-align: center;
  }
  .img-wrapper {
    height: 60px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .img-wrapper-survey {
    display: flex;
    justify-content: center;
    img {
      margin: 0 auto;
      width: auto;
      height: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    max-width: 90% !important;
    width: 90%;
  }
}
</style>
